// extracted by mini-css-extract-plugin
export default {"container":"Team_container__Wbhxc","title":"Team_title__8Q432","content":"Team_content__59RSm","teamMembers":"Team_teamMembers__ZuKf0"};